import * as React from "react";
import styled from "styled-components";
import trim from "lodash/trim";
import { Col, Row, Button, ButtonToolbar } from "components/bootstrap";
import { DocumentTitle, PageHeader, Spinner, LinkContainer } from "components/common";
import DocsHelper from "util/DocsHelper";
import ReportContents from "report/report-history-page/ReportContents";
import ReportRoutes from "report/ReportRoutes";
import LicenseCheck from "license/LicenseCheck";
import { LICENSE_SUBJECTS } from "license/constants";
import useParams from "routing/useParams";
import Icon from "components/common/Icon";
import useReportSummary from "report/report-history-page/useReportSummary";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
import ReportHistoryList from "./ReportHistoryList";
const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;
const ReportHistorySubNav = ({
  reportId,
  editAllowed,
  readAllowed
}) => /* @__PURE__ */ React.createElement(ButtonToolbar, null, readAllowed && /* @__PURE__ */ React.createElement(LinkContainer, { to: ReportRoutes.EDIT.overview(reportId) }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary" }, editAllowed ? "Edit" : "View", " configuration")));
const ReportHistoryPage = () => {
  const currentUser = useCurrentUser();
  const { reportId } = useParams();
  const { data: report, isInitialLoading } = useReportSummary(reportId, true);
  const editAllowed = isPermitted(currentUser.permissions, `report:update:${reportId}`);
  const readAllowed = isPermitted(currentUser.permissions, `report:read:${reportId}`);
  const description = !(report == null ? void 0 : report.description) || trim(report.description) === "" ? /* @__PURE__ */ React.createElement("i", null, "No further description available.") : /* @__PURE__ */ React.createElement("span", null, report.description);
  if (isInitialLoading || !report) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading report data, please wait..." });
  }
  const pageTitle = /* @__PURE__ */ React.createElement(HeaderContainer, null, /* @__PURE__ */ React.createElement(LinkContainer, { to: ReportRoutes.OVERVIEW }, /* @__PURE__ */ React.createElement(Button, { bsSize: "small" }, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_back" }), " Back")), /* @__PURE__ */ React.createElement("h1", null, report.title));
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: `${report.title} Archive` }, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: pageTitle,
      actions: /* @__PURE__ */ React.createElement(ReportHistorySubNav, { reportId: report.id, editAllowed, readAllowed }),
      documentationLink: {
        title: "Reporting documentation",
        path: DocsHelper.PAGES.REPORTING
      }
    },
    description
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ReportContents, { report })), /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ReportHistoryList, { id: report.id, editAllowed }))));
};
const ReportHistoryPageWrapper = () => /* @__PURE__ */ React.createElement(LicenseCheck, { licenseSubject: LICENSE_SUBJECTS.report, bsStyle: "danger", displayWarningContainer: true, hideChildren: true }, /* @__PURE__ */ React.createElement(ReportHistoryPage, null));
export default ReportHistoryPageWrapper;
